import React, { Suspense, useEffect, useState } from 'react';
// MUI
import { Grid, ThemeProvider } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
// Page
import SideBar from './sidebar';
import Header from './header';
// Assets
import { SALT_PAN, theme } from '../../Assets/Constants/theme';
// Route
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// Store
import { setAutoSave, updateCkbuttonStatus } from '../../Store/Redux/CKEditorSlice';

import { checkNotificationStatus } from '../../Store/DashboardSlice/DashboardSlice';

import {
  setFileds,
  setInputValues,
  setRecipientFields,
  setSignCoordiantes,
  setSingedFields
} from '../../Store/Redux/FileListSlice';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import { FetchMenuDetails, RefreshToken } from '../../Services/APIConfig';
import { setAccessToken, updateUserInfo } from '../../Store/AuthSlice/AuthSlice';
import Loading from '../Common/LoaderComponent/Loader';
import { getErrorMessage, handleLogoutUtil, parseJwt } from '../../utils/util';
import {
  addrecipientOtp,
  setLocationWhileSign,
  setPictureWhileSign
} from '../../Store/RecipientsSlice.js/RecipientsSlice';
import { useQueryParameters } from '../Common/useQueryParameters';
import CustomToast from '../Common/CustomToast';
import NoPermission from '../Pages/NoPermission';

const allowedPages = ['uam', 'dashboard', 'wallet'];

export default function MainLayout() {
  const { showToast } = CustomToast();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector(state => state.auth.userInfo);
  const isMobile = useMediaQuery('(max-width:768px)');
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [refreshToken, setRefreshToken] = useState(true);

	const refreshAccessToken = async () => {
		try {
			const refreshToken = window.localStorage.getItem('refreshToken');
			if (!refreshToken) {
				navigate('/login', { replace: true });
				setUserLoggedIn(false);
				return;
			}

			const response = await RefreshToken({ refreshToken });
			if (response?.status === 201) {
				const newAccessToken = response?.token;
				window.localStorage.setItem('authToken', newAccessToken);
				dispatch(setAccessToken(newAccessToken));
				setRefreshToken(false);
			} else {
				if (response.status === 401 || response.status === 400) {
					showToast('error', 'Session expired. Please login again.');
					handleLogoutUtil(dispatch, navigate);
					return;
				}

				showToast('error', getErrorMessage(response));
			}
		} catch (error) {
			showToast('error', getErrorMessage(error));
		}
	};

  const fetchMenuDetails = async () => {
    const response = await FetchMenuDetails();
    setIsLoading(true);
    if (response?.status === 200) {
      setIsLoading(false);
      let menu = response?.result?.[0].permissions;
      setMenuItems(response?.result);
      dispatch(
        updateUserInfo({
          menu: menu,
          userId: response?.result?.[0].userId,
          brandingChange: false,
          profileImageChanged: true,
          branding: response?.result?.[0].branding,
          orgId: response?.result?.[0].orgId,
          userName: response?.result?.[0].userName,
          userType: response?.result?.[0].userType,
          isAdmin: response?.result?.[0]?.isSuperAdmin,
          approvalEsignFlow: response?.result?.[0]?.approvalEsignFlow
        })
      );
    } else {
      setIsLoading(false);
      showToast('error', response?.message || response?.error);
    }
  };

	useEffect(() => {
		const authToken = window.localStorage.getItem('authToken');
		if (authToken) {
			setUserLoggedIn(true);
			if (!userData.menu || userData.brandingChange) {
				fetchMenuDetails();
			} else {
				setMenuItems([userData]);
			}
		} else if (refreshToken) {
			refreshAccessToken();
		} else {
			navigate('/', { replace: true });
			setUserLoggedIn(false);
		}

		if (
			location.pathname !== '/edit'
			&& location.pathname !== '/templatepreview'
		) {
			dispatch(updateCkbuttonStatus(false));
		}

		if (location.pathname !== 'dashboard') {
			dispatch(checkNotificationStatus(false));
		}

		if (location.pathname !== '/edit') {
			dispatch(setAutoSave(false));
		}
	}, [location, userData, window.localStorage.getItem('authToken')]);

  useEffect(() => {
    const link = localStorage.getItem('approval_link');
    if (link) {
      const links = link?.trimStart()?.split('/');
      if (links?.length > 2) {
        const redirectPage = links[2];
        if (allowedPages.includes(redirectPage)) {
          navigate(redirectPage);
        } else {
          localStorage.removeItem('approval_link');
        }
      } else {
        localStorage.removeItem('approval_link');
      }
    }
  }, []);



  return (
    <ThemeProvider theme={theme}>
      <ToastContainer />
      {userLoggedIn ? (
        isMobile ? (
          <Grid container sx={{ height: '100vh' }}>
            <Grid item xs={12}>
              {menuItems?.length > 0 && <Header menuItems={menuItems?.[0]} />}
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ marginTop: '80px', overflow: 'auto', paddingBottom: '80px', minHeight: 'calc(100vh - 80px)' }}
            >
              <Suspense fallback={<h1>Loading ...</h1>}>
                {menuItems?.length > 0 ? <Outlet /> : <Loading open={isLoading} />}
              </Suspense>
            </Grid>

            <Grid item xs={12}>
              {menuItems?.length > 0 && <SideBar />}
            </Grid>
          </Grid>
        ) : (
          <Grid sx={{ width: '100%' }} container>
            <Grid
              item
              xs={1}
              md={0.8}
              display={'flex'}
              justifyContent={'center'}
              lg={0.6}
              sx={{ borderRight: 1, borderColor: SALT_PAN, height: '100vh', zIndex: 100, bgcolor: 'white' }}
            >
              {menuItems?.length > 0 && <SideBar />}
            </Grid>
            <Grid item xs={11} md={11.2} lg={11.4} sx={{ marginTop: '62px' }}>
              {menuItems?.length > 0 && <Header menuItems={menuItems?.[0]} />}
              <Suspense fallback={<h1>Loading ...</h1>}>
                {menuItems?.length > 0 ? <Outlet /> : <Loading open={isLoading} />}
              </Suspense>
            </Grid>
          </Grid>
        )
      ) : null}
      {isLoading && <Loading open={isLoading} onClose={() => setIsLoading(false)} />}
    </ThemeProvider>
  );
}
